import { Icon, IconsEnum } from 'components/Icons';
import { ScommesseFiltersList } from 'components/scommesseFiltersList';
import { ScommesseSearch } from 'components/scommesseSearch';
import { LabelsBoxWithSearchType } from 'features/sport/components/sportBoxWithSearch/utils/utils';
import { setTextSearchedTipiScommessa } from 'features/sport/sportSlice';
import { useDebounce } from 'hooks';
import { useSportSearchTipiScommessa } from 'hooks/useSportSearchTipiScommessa';
import { RootState, useAppDispatch } from 'lib/centralStore';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { SEARCH_DELAY } from 'utility/constant';
import styles from './ScommesseFiltersMobileHeader.module.scss';

export type ScommesseFiltersMobileHeaderProps = {
  label: string;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
  hasSearch?: boolean;
  labels?: LabelsBoxWithSearchType;
};

export const ScommesseFiltersMobileHeader = ({
  label,
  handleClose,
  hasSearch,
  labels,
}: ScommesseFiltersMobileHeaderProps) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const { boxSearchTipiScommessa } = useSelector((root: RootState) => root.sport);
  const { debouncedValue } = useDebounce(boxSearchTipiScommessa.textSearched!, SEARCH_DELAY);
  const { getSearchData, currentData } = useSportSearchTipiScommessa(
    boxSearchTipiScommessa.indexFilter,
    router.asPath,
    debouncedValue ?? ''
  );

  return (
    <div className={styles.container}>
      <span className={styles.text}>{label}</span>
      {hasSearch && (
        <ScommesseSearch
          expandWindow={boxSearchTipiScommessa.expandWindow}
          openBtnText={labels?.searchTitle}
          placeholder={labels?.searchPlaceholder}
          onChange={(value) => dispatch(setTextSearchedTipiScommessa(value))}
          isActive={true}
          labelScommesseFound={labels?.labelScommesseFound!}
          numberOfScommesse={currentData ? currentData.length : 0}
          reset={getSearchData}
        >
          {!!currentData?.length && (
            <ScommesseFiltersList
              className={`${boxSearchTipiScommessa.expandWindow ? styles.resultsExpandend : ''}`}
              items={currentData?.map(({ isNew, descrizione, descrizioneTrKey }) => ({
                isNew: isNew,
                label: descrizione,
                labelTrKey: descrizioneTrKey,
              }))}
              selectedIndex={boxSearchTipiScommessa.indexFilter}
            />
          )}
        </ScommesseSearch>
      )}
      <button
        type="button"
        className={styles.button}
        onClick={() => {
          handleClose(false);
        }}
      >
        <Icon iconId={IconsEnum.CLOSE} className={styles.iconSmall} color={'var(--color-on-bg-primary)'} />
      </button>
    </div>
  );
};
